
import actionHelper from "@core/helper/actionHelper";

export const USER = {
  LOGIN: actionHelper("USER_LOGIN"),
  LOGOUT: actionHelper("USER_LOGOUT"),
  FETCH: actionHelper("USER_FETCH"),
  SESSION_EXPIRED: "USER_SESSION_EXPIRED",
};
